interface CarritoItem {
  productoId: number;
  nombre: string;
  cantidad: number;
  precioUnitario: number;
  descuento?: number;
  subtotal: number;
}

interface CarritoProps {
  items: CarritoItem[];
  onEliminar: (productoId: number) => void;
  onActualizarCantidad: (productoId: number, cantidad: number) => void;
  subtotal: number;
  impuestos?: number;
  propina?: number;
  incluirPropina?: boolean;
  onTogglePropina?: () => void;
  total: number;
  onCrearOrden: () => void;
  onCreateOrderAndPay: () => void;
  disabled: boolean;
}

const Carrito = ({
  items,
  onEliminar,
  onActualizarCantidad,
  subtotal,
  impuestos = 0,
  propina = 0,
  incluirPropina = false,
  onTogglePropina,
  total,
  onCrearOrden,
  onCreateOrderAndPay,
  disabled
}: CarritoProps) => {
  return (
    <div className="space-y-4">
      <h2 className="text-xl font-bold">Carrito</h2>

      {items.length === 0 ? (
        <div className="text-center py-8 text-gray-500">
          El carrito está vacío
        </div>
      ) : (
        <>
          <div className="space-y-2 max-h-96 overflow-y-auto">
            {items.map((item) => (
              <div key={item.productoId} className="bg-white p-3 rounded border">
                <div className="flex justify-between items-start mb-2">
                  <div className="flex-1">
                    <div className="font-medium text-sm">{item.nombre}</div>
                    <div className="text-xs text-gray-500">
                      ${(Number(item.precioUnitario) || 0).toFixed(2)} c/u
                    </div>
                  </div>
                  <button
                    onClick={() => onEliminar(item.productoId)}
                    className="text-red-600 hover:text-red-800"
                  >
                    ×
                  </button>
                </div>
                <div className="flex items-center space-x-2">
                  <button
                    onClick={() => onActualizarCantidad(item.productoId, item.cantidad - 1)}
                    className="px-2 py-1 border rounded hover:bg-gray-50"
                  >
                    −
                  </button>
                  <input
                    type="number"
                    min="1"
                    value={item.cantidad}
                    onChange={(e) => onActualizarCantidad(item.productoId, parseInt(e.target.value) || 1)}
                    className="w-16 px-2 py-1 border rounded text-center text-sm"
                  />
                  <button
                    onClick={() => onActualizarCantidad(item.productoId, item.cantidad + 1)}
                    className="px-2 py-1 border rounded hover:bg-gray-50"
                  >
                    +
                  </button>
                  <div className="ml-auto font-medium">
                    ${(Number(item.subtotal) || 0).toFixed(2)}
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="border-t pt-4 space-y-2">
            <div className="flex justify-between text-sm">
              <span>Subtotal:</span>
              <span>${(Number(subtotal) || 0).toFixed(2)}</span>
            </div>
            {impuestos > 0 && (
              <div className="flex justify-between text-sm text-gray-600">
                <span>Impuestos:</span>
                <span>${(Number(impuestos) || 0).toFixed(2)}</span>
              </div>
            )}
            {onTogglePropina && (
              <div className="flex items-center justify-between text-sm">
                <label className="flex items-center space-x-2 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={incluirPropina}
                    onChange={onTogglePropina}
                    className="rounded"
                  />
                  <span>Incluir propina</span>
                </label>
                {incluirPropina && propina > 0 && (
                  <span className="text-gray-600">${(Number(propina) || 0).toFixed(2)}</span>
                )}
              </div>
            )}
            <div className="flex justify-between font-bold text-lg border-t pt-2">
              <span>Total:</span>
              <span>${(Number(total) || 0).toFixed(2)}</span>
            </div>
          </div>

          <div className="space-y-2 pt-4">
            <button
              onClick={onCrearOrden}
              disabled={disabled}
              className="w-full px-4 py-2 bg-gray-600 text-white rounded hover:bg-gray-700 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Guardar Orden
            </button>
            <button
              onClick={onCreateOrderAndPay}
              disabled={disabled}
              className="w-full px-4 py-2 bg-primary-600 text-white rounded hover:bg-primary-700 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Cobrar
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default Carrito;

